import {assert, hashString} from './utils';
import {createProgram, createShader} from './webgl';
import shaderSources from './shaders';

const cache = new Map;

document.addEventListener('sde:shaders:hot', e => {
    recompilePrograms(e.detail);
});

function getSourceHash(source) {
    let hash = 0;
    for (let [k, v] of Object.entries(source))
        hash ^= hashString(k + v);
    return hash;
}

function to36(x) {
    return (x & 0x7fffffff).toString(36);
}

export function getProgram(gl, name) {
    if (cache.has(name)) {
        return cache.get(name).program;
    }

    const source = shaderSources[name];
    assert(source);

    const hash = getSourceHash(source);

    const program = createProgram(gl, source);
    cache.set(name, {
        gl,
        name,
        hash,
        program,
    });

    return program;
}

function recompilePrograms(sources) {
    for (let [name, entry] of cache.entries()) {
        const {gl, program, hash} = entry;
        const programSources = sources[name];
        assert(programSources);

        const newHash = getSourceHash(programSources);
        if (hash === newHash) {
            // ignore unchanged
            continue;
        }

        let ok = true;
        for (let shader of gl.getAttachedShaders(program)) {
            const shaderType = gl.getShaderParameter(shader, gl.SHADER_TYPE);
            const shaderKey = {
                [gl.VERTEX_SHADER]: 'vertex',
                [gl.FRAGMENT_SHADER]: 'fragment',
            }[shaderType];
            const shaderSource = programSources[shaderKey];
            assert(shaderSource);

            // compile and attach the new shader
            const newShader = createShader(gl, shaderType, shaderSource);
            if (gl.getShaderParameter(newShader, gl.COMPILE_STATUS)) {
                gl.detachShader(program, shader);
                gl.attachShader(program, newShader);
            } else {
                ok = false;
                const log = gl.getShaderInfoLog(newShader);
                console.error(`hot: recompiling ${name}.${shaderKey}:\n${log}`);
                gl.deleteShader(newShader);
            }
        }

        if (ok) {
            // relink
            gl.linkProgram(program);
            if (gl.getProgramParameter(program, gl.LINK_STATUS)) {
                entry.hash = newHash;
                console.log('hot: %s [%s]', name, to36(newHash));
            } else {
                const log = gl.getProgramInfoLog(program);
                console.error(`hot: relinking ${name}:\n${log}`);
                // probably screwed now...
            }
        }
    }
}
